import { UserRole } from "@joonapp/web-shared"
import { useQuery } from "@tanstack/react-query"

import { loadFamily } from "./api"
import useCurrentClient from "../../pages/clients/hooks/useCurrentClient"
import { QueryKey } from "../../types/queries"

// Get current patient's family
export const useFamilyQuery = () => {
  const { currentClientProfile } = useCurrentClient()

  const familyId = currentClientProfile?.user.family_id

  return useQuery({
    queryKey: [QueryKey.FAMILY, familyId],
    queryFn: () => loadFamily(familyId!),
    // Sort the family profiles so that the current client is first, then parents
    select: (data) => {
      // Filter out parents that aren't the current client profile
      const filteredProfiles = data.profiles.filter(
        (profile) =>
          profile.user.id === currentClientProfile?.user.id ||
          profile.role !== UserRole.PARENT
      )

      // Sort the remaining profiles so client is first
      const sortedProfiles = filteredProfiles.sort((a, b) => {
        if (a.user.id === currentClientProfile?.user.id) return -1
        if (b.user.id === currentClientProfile?.user.id) return 1
        return 0
      })

      return { ...data, profiles: sortedProfiles }
    },
    enabled: !!familyId,
  })
}
